<template>
  <div class="productservice ">
    <div class="productservice_header ">
      <div class="centre">
        <h3 style="margin-left: 40px;">域贝证书宝</h3>
        <p class="productservice_header_center" style="margin-left: 40px;">
          域贝证书宝系统实现了企事业单位、组织机构、社会团体等颁发电子证书的全生命周期管理，包括证书的批量制作发放、防伪溯源、查询验证、数据分析等一系列功能。
        </p>
        <div class="button" style="margin-left: 40px;" @click="openDialog">联系我们</div>
        <div class="img_box">
          <img class="seal_img" src="../../assets/images/电子证书/电子证书盖章图.png" alt="">
          <img class="shink_1" src="../../assets/images/电子证书/亮2.png" alt="">
          <img class="shink_2" src="../../assets/images/电子证书/亮1.png" alt="">
          <img class="Pane_1" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_2" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_3" src="../../assets/images/电子证书/长方块.png" alt="">
          <img class="Pane_4" src="../../assets/images/电子证书/长方块.png" alt="">
        </div>
        <div class="centre heder-bottom">
          <ul>
            <li>
              <div class="main-img">
                <img style="height:45px;margin-top: 5px;" src="../../assets/images/电子证书/办公效率分析.png" alt="">
                <img class="img_center" style="top: 42px;left: 145px;" src="../../assets/images/电子证书/pic1.png" alt="">
              </div>
              <p>提高办公效率</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:45px;margin-top: 5px;" src="../../assets/images/电子证书/碳排放管理(1).png" alt="">
                <img class="img_center" style="top: 40px;left: 440px;" src="../../assets/images/电子证书/pic2.png" alt="">
              </div>
              <p>减少碳排放</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:45px;margin-top: 5px;" src="../../assets/images/电子证书/具备更强公信力-01.png" alt="">
                <img class="img_center" style="top: 46px;left: 750px;" src="../../assets/images/电子证书/pic3.png" alt="">
              </div>
              <p>增强单位公信力</p>
            </li>
            <li>
              <div class="main-img">
                <img style="height:45px;margin-top: 5px;" src="../../assets/images/电子证书/办事.png" alt="">
                <img class="img_center" style="top: 36px;left: 1034px;" src="../../assets/images/电子证书/pic4.png" alt="">
              </div>
              <p>方便群众办事</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-1">
      <div class="centre">
        <p>平台架构</p>
      </div>
      <img src="../../assets/images/电子证书/改革前.png" alt="">
      <!-- <img class="arrow" src="../../assets/images/电子证书/大箭头.png" alt=""> -->
      <img class="main-1_right" src="../../assets/images/电子证书/改革后.png" alt="">
    </div>
    <div class="main-2">
      <div class="centre">
        <p>产品价值</p>
        <ul>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/环保便利.png" alt="">
            </div>
            <p>环保便利</p>
            <div class="text_box">
              <p>环保便利</p>
              <span class="bottom_text">告别纸质化证书，绿色环保；告别线下申领，零次跑，直接发放到个人账户；在线办结，也可自主上传，审核后自动生成电子证书 </span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/省钱省力.png" alt="">
            </div>
            <p>省钱省力</p>
            <div class="text_box">
              <p>省钱省力</p>
              <span class="bottom_text">以前，每本证书的制作需一两元，领取证书的交通费用更高；现在，制作零费用、交通零费用，估测每年可直接节约数十万元 </span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/防伪溯源.png" alt="">
            </div>
            <p>防伪溯源</p>
            <div class="text_box">
              <p>防伪溯源</p>
              <span class="bottom_text">为了保障电子证书具备法律有效性，每一张“电子证书”生成时，系统自动添加防伪二维码，加盖电子签章，使每张“电子证书”都具有唯一性，可扫描二维码对证书辨真追溯</span>
            </div>
          </li>
          <li style="margin-right: 0px;">
            <div class="main2-img">
              <img src="../../assets/images/电子证书/多级管理.png" alt="">
            </div>
            <p>多级管理</p>
            <div class="text_box">
              <p>多级管理</p>
              <span class="bottom_text">支持教育局、学校、个人多级管理模式，可根据需要灵活设置证书审核审定等管理流程  </span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/精准分析1.png" alt="">
            </div>
            <p>精准分析</p>
            <div class="text_box">
              <p>精准分析</p>
              <span class="bottom_text">全过程数据可查、大数据分析，教育部门通过系统可以全方位地了解学校、教师个人的发展现状，并为学校发展和区域数字化改革提供决策依据  </span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/设计便利.png" alt="">
            </div>
            <p>设计便利</p>
            <div class="text_box">
              <p>设计便利</p>
              <span class="bottom_text">强大的可视化证书模板编辑器，通过简单的拖拽组件即可轻松完成证书模板设计  </span>
            </div>
          </li>
          <li>
            <div class="main2-img">
              <img src="../../assets/images/电子证书/移动高效.png" alt="">
            </div>
            <p>移动高效</p>
            <div class="text_box">
              <p>移动高效</p>
              <span class="bottom_text">搭配手机端电子证书小程序，接入微信、钉钉等移动应用随时高效查询和管理证书  </span>
            </div>
          </li>
          <li style="margin-right: 0px;">
            <div class="main2-img">
              <img src="../../assets/images/电子证书/安全存储.png" alt="">
            </div>
            <p>安全存储</p>
            <div class="text_box">
              <p>安全存储</p>
              <span class="bottom_text">电子证书存储在云端，不易丢失，不再害怕保存破损，恒久保存，随时调取导出使用 </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="dialogVisible" class="callUs_dialog">
      <img class="close" src="../../assets/images/电子证书/close.png" alt="" @click="closeDialog" />
      <!-- <div class="dialog_left">
        <div class="center_box">
            <p style="font-size: 20px;">联系我们</p>
            <p style="font-size: 14px;font-weight: 500;margin-top: 15px;">完善信息后我们会第一时间跟您联系</p>
            <div class="line"></div>
            <span>您的称呼：</span>
            <el-input v-model="formLabelAlign.name"></el-input>
            <span>手机号码：</span>
            <el-input v-model="formLabelAlign.tel"></el-input>
        </div>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </div> -->
      <div class="dialog_right">
        <p>方案咨询</p>
        <img class="erw" src="../../assets/images/电子证书/ewm.png" alt=""/>
        <div class="phone_box">
          <img class="phone" src="../../assets/images/电子证书/phone.png" alt=""/>
          <span>13506670580</span>
        </div>
      </div>
    </div>
    <div v-show="dialogVisible" class="backdrop"></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      dialogVisible: false,
      formLabelAlign: {
        name: '',
        tel: ''
      },
      defferScroll: function (event) {
        event.preventDefault()
      }
    };
  },
  mounted(){
    document.addEventListener('mouseup',(e)=>{
    var button=document.querySelector('.callUs_dialog') //选择返回的第一个出现的元素
    if(button){
        if(!button.contains(e.target)){ //判断某个元素不是目标元素的子元素 即目标元素以外的区域
          this.dialogVisible=false
          this.move()
        }
      }
    })
  },
  methods: {
    onSubmit() {
      this.dialogVisible = false
    },
    openDialog() {
      this.dialogVisible = true
      document.documentElement.scrollTop = 0
      this.stop()
    },
    closeDialog() {
      this.dialogVisible = false
      this.move()
    },
    stop(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);
    },
    move(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflowY='';
      document.body.style.overflowX='hidden'
      //出现滚动条
      document.removeEventListener("touchmove",mo,false);
    }
  }
};
</script>

<style lang="less" scoped>

.centre {
  width: 1200px;
  margin: 0 auto;
}
.productservice_header {
  height: 670px;
  width: 100%;
  background-image: url('../../assets/images/电子证书/首页图.png');
  padding-top: 200px;
}
.button {
  position: relative;
  width: 131px;
  height: 48px;
  background: linear-gradient(to right, #3186fd , #63a4ff);
  border-radius: 5px;
  // border: 1px solid rgb(51,134,254);
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 100;
  cursor: pointer;
  &:hover {
    background: linear-gradient(to right, #2170de , #4f98fe);
  }
}
.img_box {
  .seal_img {
    position: absolute;
    width: 600px;
    height: 420px;
    top: 180px;
    left: 49%;
    z-index: 10;
  }
  .shink_1 {
    position: absolute;
    top: 160px;
    left: 51%;
    z-index: 10;
    animation: shink 3s infinite;
  }
  .shink_2 {
    position: absolute;
    top: 290px;
    left: 46%;
    z-index: 10;
    animation: shink 3.5s infinite;
  }
  .Pane_1 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 290px;
    left: 1%;
    z-index: 1;
    animation: heightchange1 4s infinite;
  }
  .Pane_2 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 160px;
    left: 21%;
    z-index: 1;
    animation: heightchange 4s infinite;
  }
  .Pane_3 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 150px;
    left: 35.1%;
    z-index: 1;
    animation: heightchange2 4.5s infinite;
  }
  .Pane_4 {
    position: absolute;
    width: 92px;
    height: 311px;
    top: 90px;
    left: 45%;
    z-index: 1;
    animation: heightchange3 3.8s infinite;
  }
}
@keyframes shink {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes heightchange {
  0% {
    top: 160px;
    height: 250px;
  }
  50% {
    top: 130px;
    height: 311px;
  }
  100% {
    top: 160px;
    height: 250px;
  }
}
@keyframes heightchange1 {
  0% {
    top: 290px;
    height: 250px;
  }
  50% {
    top: 320px;
    height: 311px;
  }
  100% {
    top: 290px;
    height: 250px;
  }
}
@keyframes heightchange2 {
  0% {
    top: 200px;
    height: 250px;
  }
  50% {
    top: 170px;
    height: 311px;
  }
  100% {
    top: 200px;
    height: 250px;
  }
}
@keyframes heightchange3 {
  0% {
    top: 140px;
    height: 250px;
  }
  50% {
    top: 110px;
    height: 311px;
  }
  100% {
    top: 140px;
    height: 250px;
  }
}
.productservice_header h3 {
  position: relative;
  font-size: 40px;
  font-weight: 500;
  color: #000;
  margin-bottom: 38px;
  z-index: 100;
}
.productservice_header_center {
  position: relative;
  width: 488px;
  font-size: 14px;
  letter-spacing: 2px;
  margin-bottom: 50px;
  line-height: 25px;
  z-index: 100;
}
.productservice_header button {
  width: 131px;
  height: 48px;
  font-size: 16px !important;
  background-color: linear-gradient(to right, rgb(54,131,253) , rgb(97,163,255));
  font-size: 16px;
  &:hover {
    background-color: #2170de;
  }
}
.productservice_header button span {
  font-size: 16px;
}
// 数据
.heder-bottom {
  // position: absolute;
  transform: translateY(89px);
  height: 140px;
  background-color: #fff;
  padding: 24px 0;
  box-shadow:0 2px 27px 6px rgba(0, 0, 0, .22);
  border-radius: 4px;
  z-index: 999;
}
.heder-bottom ul li {
  float: left;
  display: block;
  width: 25%;
  text-align: center;
  font-size: 16px;
  &:hover {
    .main-img .img_center {
      transform: rotate(360deg);
    }
    p {
      color: #3186fd;
    }
  }
}
.heder-bottom ul li .main-img {
  display: inline-block;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  .img_center{
    position: absolute;
    top: -40px;
    transition: 1s;
  }
}
.main-1 {
  // position: absolute;
  text-align: center;
  width: 100%;
  height: 890px;
  // background-color: rgb(231, 187, 187);
  .arrow {
    position: relative;
    top: -250px;
  }
  .main-1_right{
    transition: 1s;
    &:hover {
      transform: scale(1.2);
    }
  }
}
.main-1 .centre p {
  // margin-top: 148px;
  padding-top: 148px;
  font-size: 30px;
  color: #23405a;
  margin-bottom: 60px;
}
.main-1 .centre img {
  margin-bottom: 60px;
  height: 980px;
}
.main-2 {
  width: 100%;
  height: 770px;
  padding-top: 92px;
  text-align: center;
}
.main-2 .centre p {
  font-size: 30px;
  color: #23405a;
}
.main-2 ul {
  margin-top: 60px;
}
.main-2 ul li {
  position: relative;
  top: 0px;
  list-style: none;
  float: left;
  width: 285px;
  height: 244px;
  margin-right: 18px;
  margin-bottom: 20px;
  box-shadow:2px 5px 7px 2px rgba(0, 0, 0, .05);
  cursor: pointer;
  transition: .5s;
  overflow: hidden;
  .text_box {
    position: relative;
    top: 30px;
    width: 285px;
    height: 244px;
    background-color: #ffffff;
    border-top: rgb(49,134,253) 10px solid;
    text-align: center;
    transition: 1s;
    z-index: 10;
    p {
      display: inline-block;
      margin-top: 46px;
      font-size: 18px;
      color: #23450a;
    }
    // .bottom_text {
    //   display: inline-block;
    //   width: 153px;
    //   margin-top: 23px;
    //   line-height: 22px;
    //   color: #475d73;
    //   font-size: 14px;
    //   text-align: justify;
    // }
    .bottom_text {
      display: inline-block;
      width: 248px;
      margin-top: 23px;
      line-height: 22px;
      color: #475d73;
      font-size: 14px;
      text-align: justify;
    }
  }
}
.main-2 .centre ul li:hover {
  top: -5px;
  box-shadow:2px 5px 7px 1px rgba(0, 0, 0, .2);
  p {
    color: #3186fd;
  }
  .text_box{
    p {
      color: #000;
    }
    top: -214px;
  }
}
.main2-img {
  width: 174px;
  height: 166px;
  margin: 16px 0 0 60px;
}
.main-2 .centre ul li p {
  margin-top: 16px;
  font-size: 16px;
  color: #23405a;
}
.callUs_dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 300px;
  height: 330px;
  border-radius: 5px;
  z-index: 100000;
  background-color: rgb(243, 150, 150);
  .close {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .dialog_left {
    width: 50%;
    height: 100%;
    float: left;
    background-color: white;
    text-align: center;
    .center_box {
      position: absolute;
      top: 37px;
      left: 33px;
      width: 230px;
      height: 250px;
      display: flex;
      flex-direction: column;
      text-align: left;
      color: black;
      span,.el-input {
        margin-top: 15px;
        font-size: 16px;
      }
    }
    .el-button {
      width: 100px;
      position: relative;
      top: 285px;
    }
    .line {
        height: 5px;
        width: 30px;
        margin-top: 15px;
        border-radius: 5px;
        background-color: rgb(246,65,44);
      }
  }
  .dialog_right {
    width: 100%;
    height: 100%;
    background-color: rgb(49,134,253);
    float: right;
    span {
      font-size: 16px;
    }
    p {
      display: inline-block;
      font-size: 20px;
      color: white;
      font-weight: 100;
      margin-top: 40px;
      margin-left: 25px;
    }
    .erw{
      position: absolute;
      width: 100px;
      height: 100px;
      top: 33%;
    }
    .phone_box {
      position: relative;
      width: 130px;
      height: 20px;
      top: 180px;
      left: 90px;
      display: flex;
      color: white;
      .phone {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.backdrop{
  width:100%;
  height:100%;
  visibility: visible;
  opacity: 1;
  position:fixed;
  top:0;
  right:0;
  bottom:0;
  left:0;
  background: rgba(8, 7, 7, 0.6);
  z-index: 9999;
  // transition: all .2s ease;
  // backdrop-filter: saturate(180%) blur(1px);
}
</style>
